// @flow

import React, { FC, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import translate from '../../translate';
import { ProviderType } from 'src/types/provider';

export interface ConfirmProviderChangeContainerType {
    provider: ProviderType | null;
}

const ConfirmProviderChangeContainer: FC<ConfirmProviderChangeContainerType> = (props) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState<{ COMPANY_NAME: string; ESHOP_KEY: string } | null>(null);

    useEffect(() => {
        setInterval(() => {
            setOpen(
                props.provider?.ESHOP_KEY !== localStorage.getItem('eshopKey')
                    ? {
                        COMPANY_NAME: localStorage.getItem('eshopName') || '',
                        ESHOP_KEY: localStorage.getItem('eshopKey') || ''
                    }
                    : null
            );
        }, 5000);
    }, []);

    if (!open) {
        return null;
    }

    const setActual = () => {
        localStorage.setItem('eshopKey', props.provider?.ESHOP_KEY || '');
        localStorage.setItem('eshopName', props.provider?.COMPANY_NAME || '');
        setOpen(null);
    };

    const setNew = () => {
        navigate(`/`);
        window.location.reload();
    };

    return (
        <Dialog open>
            <DialogTitle id="provider-change-dialog-title">{translate('confirmProviderChange.title')}</DialogTitle>
            <DialogContent dividers>{translate('confirmProviderChange.text1')}<br />
                {translate('confirmProviderChange.text2')}</DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" onClick={setActual}>
                    {props.provider?.COMPANY_NAME}
                </Button>
                <Button color="primary" variant="outlined" onClick={setNew}>
                    {open?.COMPANY_NAME}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmProviderChangeContainer;
